// GRAVY-10404: the "Suspended" tier-badge rule, in ONE place.
//
// A worker who is suspended or permanently removed shows a single "Suspended"
// badge in place of their dependability tier, on EVERY surface that renders the
// tier badge (worker profile card, Workers list table + mobile card, …). This
// is DISPLAY-ONLY — the score number is never touched; only the tier label/badge
// is overridden. Centralizing the rule here (instead of re-deriving it per
// screen) is what keeps the surfaces from drifting apart.
//
// "Suspended" must stay visually distinct from Monitored (a low-score tier, red)
// and from the no-show caution badge — hence its own dark "blocked" color token
// (dependabilityV2Colors.depSuspended), used by the card pill and the shared
// Badge `suspended` variant alike.

export type WorkerAccountabilityStatus =
  | 'active'
  | 'suspended'
  | 'permanently_removed';

export const SUSPENDED_BADGE_LABEL = 'Suspended';

// A worker reads as "suspended" (dark badge, tier hidden) when EITHER:
//   - the backend's authoritative `is_suspended` flag is true — it reflects an
//     active suspension record (temporary OR permanent), the SAME signal the
//     admin suspension banner uses, so the badge agrees with the banner even
//     when the denormalized accountability_status column lags (GRAVY-10404); or
//   - the accountability_status string is a blocked state — the backward-compat
//     fallback for a payload that predates `is_suspended` (rolling deploy).
// An absent/unknown status (e.g. `not_rated`) with no is_suspended flag is
// treated as not-suspended, so the tier still shows.
export const isWorkerSuspended = (
  accountabilityStatus?: string | null,
  isSuspended?: boolean | null,
): boolean =>
  isSuspended === true ||
  accountabilityStatus === 'suspended' ||
  accountabilityStatus === 'permanently_removed';
